import { useSortable } from "@dnd-kit/sortable";
import { ContentConfig, ContentCreate, DinamicGridCreate, TypeDinamicGrid } from "../dinamyc-pages.types";
import { CSS } from '@dnd-kit/utilities'
import { i18n } from '../../../../translate/i18n'
import { Dispatch, SetStateAction, useState } from "react";
import { ContentFieldInput } from "./contentInputConfig";
import { useDinamicPages } from "../factory/useDinamicPages";
import Swal from "sweetalert2";

type Props = {
    block: DinamicGridCreate
    removeBlock: (id: string) => void
    updateBlock: (id: string, data: DinamicGridCreate) => void
}

const previewContent = (block: DinamicGridCreate, data: ContentCreate, setData: Dispatch<SetStateAction<ContentCreate>>) => {

    const fields = ContentConfig[block.type]

    return (
        <div className='d-grid gap-3'>
            {fields.map((field) => (
                <ContentFieldInput
                    key={field.field}
                    config={field}
                    data={data}
                    setData={setData}
                />
            ))}
        </div>
    )



}




export function SortableGrid({ block, removeBlock, updateBlock }: Props) {
    const [isDeleting, setIsDeleting] = useState(false) // State de bloqueio

    const {
        attributes,
        listeners,
        setNodeRef,
        setActivatorNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: block.id,
        disabled: isDeleting // Desabilita o Drag & Drop enquanto deleta
    })

    const { deleteGridAggregatorDinamicPage } = useDinamicPages()

    const handleUpdateContent: Dispatch<SetStateAction<ContentCreate>> = (value) => {
        if (!updateBlock || isDeleting) return;

        const configuration = typeof value === 'function'
            ? value(block.configuration)
            : value;

        updateBlock(block.id, { ...block, configuration });
    };

    async function deleteGrid(gridId: string | number) {
        if (isDeleting) return // Trava chamadas simultâneas

        setIsDeleting(true) // Inicia o bloqueio

        try {
            const isNumeric = typeof gridId === 'number' || /^\d+$/.test(String(gridId));
            if (isNumeric) {
                // Converte a string numérica em number para a função
                await deleteGridAggregatorDinamicPage(Number(gridId));
            }
            removeBlock(gridId as string)
        } catch (error) {
            Swal.fire({
                icon: 'warning',
                title: 'Um Erro aconteceu',
                text: 'Não foi possivel remover o grid dessa página'
            })
        } finally {
            setIsDeleting(false) // Libera o estado no encerramento (mesmo se der erro)
        }
    }

    return (
        <article
            ref={setNodeRef}
            className={`card border-0 shadow-sm ${isDragging ? 'opacity-50' : ''} ${isDeleting ? 'opacity-75' : ''}`}
            style={{
                transform: CSS.Transform.toString(transform),
                transition,
                position: 'relative',
                pointerEvents: isDeleting ? 'none' : 'auto' // Bloqueia interações do mouse
            }}
            aria-roledescription='sortable item'
        >
            <div className='card-header bg-white d-flex align-items-center gap-3 py-3'>
                {/* HANDLE — desabilitado no estado de isDeleting */}
                <button
                    type='button'
                    className='btn btn-light border'
                    ref={setActivatorNodeRef}
                    {...listeners}
                    {...attributes}
                    disabled={isDeleting}
                    aria-label={i18n.t('service_requests.drag_title')}
                    title={i18n.t('service_requests.drag_title')}
                >
                    <i className='bi bi-grip-vertical' />
                </button>

                <div className='flex-grow-1'>
                    <h3 className='h5 fw-bold mb-1'>Grid {block.order}</h3>
                    <span className='badge text-primary fs-6 text-capitalize'>{String(block.type)}</span>
                </div>

                {/* BOTÃO DE DELETAR — com spinner e estado disabled */}
                <button
                    type='button'
                    className='btn btn-outline-danger d-flex align-items-center justify-content-center'
                    onClick={() => deleteGrid(block.id)}
                    title='Remover grid'
                    disabled={isDeleting}
                    style={{ minWidth: '42px', minHeight: '38px' }}
                >
                    {isDeleting ? (
                        <span className='spinner-border spinner-border-sm text-danger' role='status' aria-hidden='true' />
                    ) : (
                            <i className='bi bi-trash text-danger' />
                        )}
                </button>
            </div>

            {/* Preview só visual e compacto */}
            <div className='card-body'>{previewContent(block, block.configuration, handleUpdateContent)}</div>
        </article>
    )
}